import React from "react";
import { connect } from "react-redux";
import { path } from "ramda";
import { ContainerLoading, PreloadDiv } from "../../../../components/loading/PersistGateLoading";
import { ReducerKeys } from "../../../../reducers";
import ProgressBar from "../../../../components/bar/ProgressBar";
import { TargetValueType, LoadingKey, CompareCol } from "../../CompareValuePanel";
import CounChartList, { SupportGraphs } from "../../../../components/report/counseling/CounChartList";
import I18n from "../../../../i18n";
import { isFunction } from "../../../../util";

class CounOverviewPanel extends React.Component{
    state = {
    	summary:{},
    	viewMain: null,
    	loading: false,
    }
    constructor(props){
    	super(props);
    	const { setRef } = props;
    	if(isFunction(setRef)){
    		setRef(this);
    	}
    }

    componentDidMount(){
    	const { fetchMain, targetValueType } = this.props;
    	if(isFunction(fetchMain)){
    		fetchMain(targetValueType).then(summary=>{
    			this.setState({summary});
    		});
    	}
    }
    updateMain(getPromise, errorOnInfo = true){
    	this.setState({loading: true, viewMain:null},()=>{
    		getPromise().then(summary=>{
    			this.setState({
    				summary,
    				loading: false,
    			});
    		}).catch(error=>{
    			console.error("fetchCounOverview.error: ",error);
    			this.setState({
    				summary: {},
    				loading: false,
    			});
    		});    
    	});
    }
    
    render(){
    	const { organization, targetValueType, isVertical } = this.props;
    	const { summary, loading } = this.state;
    	return <ContainerLoading isLoading={loading} loadingChildren={<PreloadDiv />} >
    		<CounChartList 
    			perRow = {isVertical ? 2 : 3} 
    			height = {275}
    			summary={summary} 
    			colorType={targetValueType} 
    			short={true} 
    			isVertical={isVertical}
    			showLegend={!isVertical}
    			showValue={false}
    			pushOnTypeClick={true}
    			// exclude={[SupportGraphs.PatientFeedback, SupportGraphs.ProviderFeedback]}
    		/>
    	</ContainerLoading>;
    }
}

function state2props(state){
	return { organization: path([ReducerKeys.ORGANIZATION, "organization"], state)};
}
export default connect(state2props)(CounOverviewPanel);


// WEBPACK FOOTER //
// ./src/containers/ReportPanels/Counseling/Panels/CounOverviewPanel.js